import type { IdTokenClaims } from "@/types/auth";

/** Decodes a JWT payload without verifying the signature (verification happens server-side). */
export function decodeJwtPayload<T = IdTokenClaims>(token: string): T {
  const payload = token.split(".")[1];
  if (!payload) throw new Error("Malformed token");
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const json = decodeURIComponent(
    atob(padded)
      .split("")
      .map((char) => "%" + char.charCodeAt(0).toString(16).padStart(2, "0"))
      .join(""),
  );
  return JSON.parse(json) as T;
}
